/**
 * Textos WA Cloud (mismas plantillas Twilio). Listado: «Plantilla X»;
 * lupa: texto completo + opciones de respuesta (botones).
 */
const CUERPOS = {
  confirmar_cita:
    '¡Hola {{1}}! Te escribimos para recordarte tu próxima visita con nosotros 🧡\n📅 Fecha: {{2}}\n🕐 Hora: {{3}}\n👤 Agente: {{4}}\n\n¿Todo OK por tu parte?',
  visita_reservado:
    '¡Hola {{1}}! 🎉 Enhorabuena por tu nueva vivienda! Ha sido un placer acompañarte y nos alegramos mucho de que hayas encontrado lo que buscabas.\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_sigue_1_vivienda:
    '¡Hola {{1}}! Gracias por tu tiempo hoy. Nos alegra saber que el {{2}} de la {{3}} te ha gustado y esperamos ayudarte a dar el siguiente paso pronto 😊\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_sigue_varias_viviendas:
    '¡Hola {{1}}! Gracias por tu tiempo hoy. Nos alegra saber que las {{2}} viviendas que te han interesado tienen opciones y esperamos ayudarte a dar el siguiente paso pronto 😊\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_objeciones_1_vivienda:
    '¡Hola {{1}}! Gracias por tu tiempo en la visita de hoy. Sabemos que el {{2}} de la {{3}} necesita valorarlo con calma, y seguimos aquí para ayudarte cuando estés listo/a 😊\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_objeciones_varias_viviendas:
    '¡Hola {{1}}! Gracias por tu tiempo en la visita de hoy. Sabemos que las {{2}} viviendas que te han interesado necesitan valorarlo con calma, y seguimos aquí para ayudarte cuando estés listo/a 😊\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_descarte:
    '¡Hola {{1}}! Gracias por tu tiempo hoy. Lamentamos que las viviendas visitadas no hayan encajado con lo que buscas, pero estamos aquí si en algún momento podemos ayudarte 🏠\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_descarte_1_vivienda:
    '¡Hola {{1}}! Gracias por tu tiempo hoy. Lamentamos que el {{2}} de la {{3}} no haya encajado con lo que buscas, pero estamos aquí si en algún momento podemos ayudarte 🏠\n\n¿Cómo ha sido tu experiencia en la visita?',
  visita_descarte_varias_viviendas:
    '¡Hola {{1}}! Gracias por tu tiempo hoy. Lamentamos que las {{2}} viviendas visitadas no hayan encajado con lo que buscas, pero estamos aquí si en algún momento podemos ayudarte 🏠\n\n¿Cómo ha sido tu experiencia en la visita?',
};

const BOTONES = {
  confirmar_cita: ['Confirmo', 'No puedo'],
  visita_reservado: ['Mala', 'Buena', 'Excelente'],
  visita_sigue_1_vivienda: ['Mala', 'Buena', 'Excelente'],
  visita_sigue_varias_viviendas: ['Mala', 'Buena', 'Excelente'],
  visita_objeciones_1_vivienda: ['Mala', 'Buena', 'Excelente'],
  visita_objeciones_varias_viviendas: ['Mala', 'Buena', 'Excelente'],
  visita_descarte: ['Mala', 'Buena', 'Excelente'],
  visita_descarte_1_vivienda: ['Mala', 'Buena', 'Excelente'],
  visita_descarte_varias_viviendas: ['Mala', 'Buena', 'Excelente'],
};

const VAR_KEYS = {
  confirmar_cita: ['nombre', 'fecha', 'hora', 'agente'],
  visita_reservado: ['nombre'],
  visita_sigue_1_vivienda: ['nombre', 'tipo', 'calle'],
  visita_sigue_varias_viviendas: ['nombre', 'num_viviendas'],
  visita_objeciones_1_vivienda: ['nombre', 'tipo', 'calle'],
  visita_objeciones_varias_viviendas: ['nombre', 'num_viviendas'],
  visita_descarte: ['nombre'],
  visita_descarte_1_vivienda: ['nombre', 'tipo', 'calle'],
  visita_descarte_varias_viviendas: ['nombre', 'num_viviendas'],
};

function anexarBotones(texto, plantillaId) {
  const botones = BOTONES[plantillaId] || [];
  if (!texto || !botones.length) return texto;
  if (/Opciones de respuesta:/i.test(texto)) return texto;
  return `${texto}\n\nOpciones de respuesta:\n${botones.map((b) => `• ${b}`).join('\n')}`;
}

export function renderTextoPlantillaWa(plantillaId, variables = {}) {
  const cuerpo = CUERPOS[plantillaId];
  if (!cuerpo) return null;
  const keys = VAR_KEYS[plantillaId] || [];
  let texto = cuerpo;
  keys.forEach((key, i) => {
    texto = texto.split(`{{${i + 1}}}`).join(String(variables[key] ?? ''));
  });
  return anexarBotones(texto, plantillaId);
}

/** Extrae id de «Plantilla visita_reservado» / metadata. */
function plantillaIdDesdeHistorial(h, meta = {}) {
  if (meta.plantilla_id) return String(meta.plantilla_id);
  const m = String(h?.contenido || '').match(/^Plantilla\s+([a-z0-9_]+)/i);
  return m ? m[1] : null;
}

/** Contenido completo para la lupa del historial WA. */
export function textoCompletoHistorialWa(h, meta = {}) {
  const plantillaId = plantillaIdDesdeHistorial(h, meta);
  if (meta.texto_completo) {
    return anexarBotones(String(meta.texto_completo), plantillaId);
  }
  if (plantillaId) {
    const rendered = renderTextoPlantillaWa(plantillaId, meta.variables || {});
    if (rendered) return rendered;
  }
  return h?.contenido || '';
}
